import Head from 'next/head';
import type { Thing } from 'schema-dts';

import { usePublicAppContext } from '_core/context/public-app-context';

import { generateOrganization } from './HomepageJsonld';
import { escapeJsonLd } from './utils';

export const OrganizationJsonLd = () => {
  const { domainInfo } = usePublicAppContext();
  const graph: { '@context': string; '@graph': Thing[] } = {
    '@context': 'https://schema.org',
    '@graph': [generateOrganization({ origin: domainInfo?.getOriginUrl() ?? '' })],
  };

  return (
    <Head>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: escapeJsonLd(JSON.stringify(graph)) }} />
    </Head>
  );
};
